import { render } from "./Currency.vue?vue&type=template&id=7d57591a"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"

import "./Currency.vue?vue&type=style&index=0&id=7d57591a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Currency.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d57591a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d57591a', __exports__)) {
    api.reload('7d57591a', __exports__)
  }
  
  module.hot.accept("./Currency.vue?vue&type=template&id=7d57591a", () => {
    api.rerender('7d57591a', render)
  })

}


export default __exports__